import inView from 'in-view'
import smoothscroll from 'smoothscroll-polyfill'
import lottie from 'lottie-web'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  current: 'is-current',
  large: 'is-large',
  nav: 'view-navigation',
  bottom: 'is-bottom',
  dark: 'is-dark',
}

/**
 * Get the URL parameter value
 *
 * @param name {string} パラメータのキー文字列
 * @param url {string} 対象のURL文字列（任意）パラメータのキー文字列
 * @return string
 */
const getParam = (name, url) => {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

/**
 * scroll inView animation
 */
const inViewSet = () => {
  inView('.inview').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-fadeUp').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-fadeLeft').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-fadeRight').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-fadeIn').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-sliderInLeft').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-sliderInRight').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-slideOut-background--black').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-slideOut-background--red').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-slideIn-background').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-slideIn-background--red').on('enter', (el) => {
    el.classList.add('is-view')
  })

  inView('.js-slideIn-background--white').on('enter', (el) => {
    el.classList.add('is-view')
  })
}

const scrollSmooth = (targetId, transion) => {
  smoothscroll.polyfill()
  const behavior = transion || 'smooth'
  const rectTop = document.querySelector(targetId).getBoundingClientRect().top
  const top = rectTop + window.scrollY - document.querySelector('.header').clientHeight
  window.scrollTo({ top, behavior })
}

const pageTop = () => {
  const pageTopButton = document.querySelector('.page-top')

  if (pageTopButton) {
    pageTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    })
  }
}

const mountPageTopAnimation = () => {
  const lottiePageTopAnimationInit = {
    container: document.getElementById('pageTopMotion'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/wp-content/themes/HDJ2023_v1/assets/json/scrolltop.json',
  }

  const lottiePageTopAnimation = lottie.loadAnimation(lottiePageTopAnimationInit)
  lottiePageTopAnimation.play()
}

/**
 * 店舗情報を各DOMへ設定
 */
const setShopViewData = () => {
  const currentShopName = localStorage.getItem('shopName')
  const currentShopID = localStorage.getItem('shopID')
  const currentShopSlug = localStorage.getItem('shopSlug')
  const currentShopBikeID = localStorage.getItem('goBikeID')
  const currentShopLogoPath = localStorage.getItem('logoPath')
  const currentShopTel = localStorage.getItem('shopTel')

  if (currentShopID) {
    if (document.querySelector('[data-shop-logo]')) {
      document.querySelector('[data-shop-logo]').setAttribute('src', currentShopLogoPath)
    }

    Array.from(document.querySelectorAll('[data-shop-tel]')).forEach((el) => {
      el.setAttribute('href', `tel:${currentShopTel.replace(/-/g, '')}`)
      if (el.getAttribute('data-hide-text') !== 'true') {
        el.innerText = currentShopTel
      }
    })
    Array.from(document.querySelectorAll('[data-rental-bike-link]')).forEach((el) => {
      el.setAttribute('href', `https://hondago-bikerental.jp/store/detail/${currentShopBikeID}`)
    })
    Array.from(document.querySelectorAll('[data-shop-top-link]')).forEach((el) => {
      el.setAttribute('href', `/shop/${currentShopSlug}`)
    })
    Array.from(document.querySelectorAll('[data-inquiry-link]')).forEach((el) => {
      el.setAttribute('href', `/inquiry/?shop_id=${currentShopID}`)
    })
    Array.from(document.querySelectorAll('[data-information-link]')).forEach((el) => {
      el.setAttribute('href', `/category/information/?shop_id=${currentShopID}`)
    })
    Array.from(document.querySelectorAll('[data-event-link]')).forEach((el) => {
      el.setAttribute('href', `/category/event/?shop_id=${currentShopID}`)
    })

    Array.from(document.querySelectorAll('[data-information-shop-filter]')).forEach((el) => {
      if (currentShopName) {
        el.innerText = `(${currentShopName})`
      }
    })
  } else if (document.querySelector('[data-shop-tel-wrap]')) {
    document.querySelector('[data-shop-tel-wrap]').remove()
  }

  Array.from(document.querySelectorAll('[data-has-list]')).forEach((nav) => {
    nav.addEventListener('click', () => {
      nav.classList.toggle('is-open')

      if (nav.classList.contains('is-open')) {
        Array.from(document.querySelectorAll('[data-has-list]')).forEach((nav2) => {
          if (nav2 !== nav) {
            nav2.classList.remove('is-open')
          }
        })
      }
    })
  })
}

export { klass, getParam, inViewSet, scrollSmooth, pageTop, mountPageTopAnimation, setShopViewData }
